import classNames from 'classnames/bind';
import styles from './BannerRegister.module.scss';
import ButtonElement from '@/views/elements/button/ButtonElement';

import { ReactComponent as IconLongDot } from '@/views/assets/icons/longdot.svg';
import { ReactComponent as IconShortDot } from '@/views/assets/icons/shortdot.svg';
import { useEffect, useRef, useState } from 'react';
import { TYPE_REGISTER } from '../HomeCPComponent';
import TypographyElement from '@/views/elements/typography/TypographyElement';
import { useTranslation } from 'react-i18next';

const cx = classNames.bind(styles);

type Props = {
    handleRegister: (mode: TYPE_REGISTER) => void
}


export default function BannerRegister({ handleRegister }: Props) {
    const { t } = useTranslation()
    const [mode, setMode] = useState<TYPE_REGISTER>("FOLLOWER")
    const timerRef = useRef<number | null>(null)
    const pauseRef = useRef<boolean | null>(null)

    useEffect(() => {
        timerRef.current && clearInterval(timerRef.current)
        timerRef.current = setInterval(() => {
            if (pauseRef.current === true) {
                return;
            }

            if (mode === 'FOLLOWER') {
                setMode('MASTER')
            } else {
                setMode('FOLLOWER')
            }
        }, 5 * 1000);

        () => {
            timerRef.current && clearInterval(timerRef.current)
        }
    }, [mode])

    useEffect(() => {
        const safeArea = document.getElementById("safe-area");

        const listenerMouseover = safeArea?.addEventListener('mouseover', () => {
            pauseRef.current = true;
        });

        const listenerMouseout = safeArea?.addEventListener('mouseout', () => {
            pauseRef.current = false;
        });

        // Clean up the event listeners when the component unmounts
        return () => {
            if (safeArea) {
                listenerMouseover && safeArea.removeEventListener('mouseover', listenerMouseover);
                listenerMouseout && safeArea.removeEventListener('mouseout', listenerMouseout);
            }
        };
    }, []);


    return (
        <div id="safe-area" className={cx("hint-register")}>
            <div className={cx("hint-custom")}>
                <div className={cx("hint-content")}>

                    {mode === "FOLLOWER" && <TypographyElement FontSizeElement='16px' FontWeightElement={700} ColorElement='primary'>{t("copytrade.banner.follower")}</TypographyElement>}
                    {mode === "MASTER" && <TypographyElement FontSizeElement='16px' FontWeightElement={700} ColorElement='primary'>{t("copytrade.banner.master")}</TypographyElement>}
                </div>
                {mode === "FOLLOWER" && <div className={cx("tab-select")}>
                    <span className={cx("icon-tab-select")} onClick={() => setMode('FOLLOWER')}>
                        <IconLongDot />
                    </span>
                    <span className={cx("icon-tab-select")} onClick={() => setMode('MASTER')}>
                        <IconShortDot />
                    </span>
                </div>}

                {mode === "MASTER" && <div className={cx("tab-select")}>
                    <span className={cx("icon-tab-select")} onClick={() => setMode('FOLLOWER')}>
                        <IconShortDot />
                    </span>
                    <span className={cx("icon-tab-select")} onClick={() => setMode('MASTER')}>
                        <IconLongDot />
                    </span>
                </div>}

            </div>

            <ButtonElement size='small' className={cx("btn-register")} onClick={() => handleRegister(mode)} >{t("copytrade.common.register")}</ButtonElement>
        </div>
    )
}